import { render, staticRenderFns } from "./CategoryBudget.vue?vue&type=template&id=7fcdf601&scoped=true"
import script from "./CategoryBudget.vue?vue&type=script&lang=js"
export * from "./CategoryBudget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcdf601",
  null
  
)

export default component.exports